export default function MySQL_DATABASE() {
  return (
    <div>
      <h2>MySQL_DATABASE</h2>    </div>
  );
}